import styled from 'styled-components';
import { Button } from '../ui/Button';

const NavContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  
  @media (min-width: 1024px) {
    gap: 1rem;
  }
  
  @media (min-width: 1440px) {
    gap: 1.25rem;
  }
`;

const CategoryButton = styled(Button).attrs(props => ({
  // Filter out the 'active' prop so it doesn't get passed to DOM
  active: undefined
}))`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  transition: all 0.3s;
  
  @media (min-width: 1024px) {
    padding: 0.625rem 1.25rem;
    font-size: 0.9375rem;
    gap: 0.625rem;
  }
  
  @media (min-width: 1440px) {
    padding: 0.75rem 1.5rem;
    font-size: 1rem;
    gap: 0.75rem;
  }
  
  ${props => props.$active ? `
    background-color: ${props.theme.colors.primary};
    color: ${props.theme.colors.primaryForeground};
  ` : `
    background-color: ${props.theme.colors.secondary};
    color: ${props.theme.colors.secondaryForeground};
    &:hover {
      background-color: ${props.theme.colors.muted};
    }
  `}
`;

const ColorDot = styled.span`
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 9999px;
  background-color: ${props => {
    const color = props.color;
    return props.theme.colors.category[color] || props.theme.colors.primary;
  }};
  
  @media (min-width: 1024px) {
    width: 0.625rem;
    height: 0.625rem;
  }
  
  @media (min-width: 1440px) {
    width: 0.75rem;
    height: 0.75rem;
  }
`;

const Count = styled.span`
  font-size: 0.75rem;
  opacity: 0.6;
  
  @media (min-width: 1024px) {
    font-size: 0.8125rem;
  }
  
  @media (min-width: 1440px) {
    font-size: 0.875rem;
  }
`;

const CategoryNav = ({ categories, activeCategory, onCategoryChange }) => {
  return (
    <NavContainer>
      <CategoryButton
        $active={activeCategory === 'all'}
        onClick={() => onCategoryChange('all')}
      >
        All Posts
      </CategoryButton>
      
      {categories.map((category) => (
        <CategoryButton
          key={category.name}
          $active={activeCategory === category.name}
          onClick={() => onCategoryChange(category.name)}
        >
          <ColorDot color={category.color} />
          {category.name}
          <Count>({category.count})</Count>
        </CategoryButton>
      ))}
    </NavContainer>
  );
};

export default CategoryNav;

